import {
  ApplePay,
  CardPayment,
  CloseIcon,
  GooglePay,
  Text
} from '@/components/atomic/nuclei';
import { DEVICE_SURFACE } from '@/config/common';
import { GOOGLE_PAY_ENABLED } from '@/config/tapPayments';
import { GetUiDeviceSurface } from '@/helpers/screenResolutionHelper';
import isIos from '@/lib/device';

const PaymentWidgetHeaderWeb = ({ transactionAmount }) => (
  <Text
    {...{
      className: 'text-base md:text-xl text-white font-medium mb-4',
      content: `Paying AED ${transactionAmount}`
    }}
  />
);

const PaymentWidgetHeaderMobile = ({
  headerColorClass,
  renderCloseIcon,
  setIsOpen,
  setRenderTapPaymentWidget,
  transactionAmount
}) => (
  <div className='flex justify-between'>
    <Text
      {...{
        className: `${headerColorClass} text-base md:text-xl font-medium mb-2`,
        content: `Paying AED ${transactionAmount}`
      }}
    />
    {renderCloseIcon && (
      <CloseIcon
        onClick={() => {
          setIsOpen(false);
          setRenderTapPaymentWidget(false);
        }}
      />
    )}
  </div>
);

const TapPaymentWidget = ({
  buttonBackgroundColorClass,
  cardPaymentButtonClass,
  containerClass = 'w-full rounded-b-2xl md:rounded-bl-none md:rounded-r-2xl',
  headerColorClass,
  hostEmail,
  hostMobile,
  hostName,
  onClickPayAmount,
  renderCloseIcon = true,
  sdkContainerAdditionalClass = '',
  separatorColor = '',
  setIsOpen,
  setLoading,
  setRenderTapPaymentWidget,
  setShowToast,
  setTapSanitizedToken,
  showHeader = false,
  textColorClass,
  transactionAmountInUpperDenomination: transactionAmount
}) => {
  const deviceSurface = GetUiDeviceSurface();
  const PaymentWidgetHeaderMap = {
    [DEVICE_SURFACE.MOBILE]: PaymentWidgetHeaderMobile,
    [DEVICE_SURFACE.WEB]: PaymentWidgetHeaderWeb
  };
  const PaymentWidgetHeader = PaymentWidgetHeaderMap[deviceSurface];

  const isMobile = deviceSurface === DEVICE_SURFACE.MOBILE;
  const shouldRenderApplePay = !isMobile || isIos();
  const shouldRenderGooglePay = GOOGLE_PAY_ENABLED;
  const shouldRenderWalletRow = shouldRenderGooglePay || shouldRenderApplePay;

  return (
    <div className={containerClass}>
      {showHeader && (
        <PaymentWidgetHeader
          {...{
            headerColorClass,
            renderCloseIcon,
            setIsOpen,
            setRenderTapPaymentWidget,
            transactionAmount
          }}
        />
      )}
      <div className={`gap-2 mt-2 ${sdkContainerAdditionalClass}`}>
        <CardPayment
          {...{
            buttonBackgroundColorClass,
            cardPaymentButtonClass,
            onClickPayAmount,
            setTapSanitizedToken,
            textColorClass,
            transactionAmount
          }}
        />
        {shouldRenderWalletRow && (
          <div className={`text-center font-semibold ${separatorColor}`}>OR</div>
        )}
        {shouldRenderWalletRow && (
          <div className='flex flex-row w-full'>
            {shouldRenderGooglePay && (
              <div className={shouldRenderApplePay ? 'w-1/2 p-2' : 'w-full p-2'}>
                <GooglePay
                  {...{
                    onClickPayAmount,
                    setLoading,
                    setShowToast,
                    setTapSanitizedToken,
                    transactionAmount
                  }}
                />
              </div>
            )}
            {shouldRenderApplePay && (
              <div className={shouldRenderGooglePay ? 'w-1/2 p-2' : 'w-full p-2'}>
                <ApplePay
                  {...{
                    hostEmail,
                    hostMobile,
                    hostName,
                    onClickPayAmount,
                    setTapSanitizedToken,
                    transactionAmount
                  }}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TapPaymentWidget;
